<script setup lang="ts">
import { useSessionStore } from '../../../stores';
import { Session } from '../../../types/session';
import Fullscreen from '../../General/Fullscreen.vue';
import Iframe from '../../General/Iframe.vue';

const sessionStore = useSessionStore()
</script>

<template>
    <template v-if="sessionStore.classContent?.[Session.workbook]?.scormUrl && sessionStore.classContent?.[Session.workbook]?.scormUrl != ''">
        <Fullscreen class="p-3 h-full flex flex-col items-center justify-evenly overflow-auto">
            <Iframe :src="sessionStore.classContent?.[Session.workbook]?.scormUrl" orientation="full"></Iframe>
        </Fullscreen>
    </template>
    <Fullscreen v-else class="p-3 h-full flex flex-col items-center justify-evenly overflow-auto">
        <Iframe v-if="sessionStore.classContent?.[Session.workbook]?.url"
            :src="sessionStore.classContent[Session.workbook].url" orientation="vertical" />
    </Fullscreen>
</template>